import React from 'react';
import { PropTypes } from 'prop-types';
import MakeModelComments from '../components/make-model-comments';

const MakeModelDetailRow = ({ comments }) => {
  return (
    <div className="grid-container">
      <div className="grid-row border-bottom border-base-lighter padding-bottom-1">
        <div className="grid-col flex-1 text-bold margin-bottom-105">
          Comments
        </div>
        <div className="grid-col flex-5">
          <MakeModelComments comments={comments} />
        </div>
      </div>
    </div>
  );
};

MakeModelDetailRow.propTypes = {
  comments: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      comment: PropTypes.string,
      createdAt: PropTypes.string,
      createdBy: PropTypes.string,
      createdByUser: PropTypes.shape({
        email: PropTypes.string,
        fullName: PropTypes.string,
      }),
    }),
  ).isRequired,
};

export default MakeModelDetailRow;
